import { BaseElement } from './base-element';

export class ShelfElement extends BaseElement {


    /**
     * @var
     */
    articleNumber: string;

    /**
     * @var
     */
    image: string;

    /**
     * @var
     */
    isFloorElement: boolean;

    /**
     * @var
     */
    isEdgeElement: boolean;

    /**
     * @var
     */
    isTopElement: boolean;

    /**
     * @var
     */
    group: string;


    public constructor(id: number, name: string, articleNumber: string, width: number, length: number, height: number, model3d: string, image: string, isFloorElement: boolean, isEdgeElement: boolean, isTopElement: boolean) {

        super(id, name, width, length, height, model3d);

        this.articleNumber = articleNumber;
        this.image = image;
        this.isFloorElement = isFloorElement;
        this.isEdgeElement = isEdgeElement;
        this.isTopElement = isTopElement;

    }
}



// WEBPACK FOOTER //
// ./src/app/shelf-element.ts